var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUploadPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1666 14.75H6.33329C5.41246 14.75 4.66663 14.0415 4.66663 13.1667V4.45833C4.66663 3.58354 5.41246 2.875 6.33329 2.875H17.1666C18.0875 2.875 18.8333 3.58354 18.8333 4.45833V13.1667C18.8333 14.0415 18.0875 14.75 17.1666 14.75Z",
    stroke: "#556ED1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.83 17.125H3.83329C2.91246 17.125 2.16663 16.4164 2.16663 15.5416V7.14917",
    stroke: "#556ED1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9547 5.90021C10.4972 6.41558 10.4972 7.25118 9.9547 7.76655C9.4122 8.28193 8.53263 8.28193 7.99013 7.76655C7.44763 7.25117 7.44763 6.41558 7.99013 5.90021C8.53263 5.38483 9.4122 5.38483 9.9547 5.90021",
    stroke: "#556ED1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8333 11.4512L16.0116 9.30655C15.6524 9.03343 15.1274 9.08884 14.8399 9.43005L12.6966 11.9753C12.4091 12.3165 11.8849 12.3719 11.5249 12.0988L10.4424 11.2762C10.0883 11.0071 9.57242 11.0561 9.28159 11.3878L6.33325 14.7501",
    stroke: "#556ED1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUploadPhoto);
export default __webpack_public_path__ + "static/media/iconUploadPhoto.cc94f72a5cc6a7124da21f2d31ca579b.svg";
export { ForwardRef as ReactComponent };